window.onload = function() {
    if (window.location.href.indexOf("#mpr-form") > -1) {
        document.querySelector("body").classList.add("hide-reg-form");
      
    }
};
// Get the current URL
var currentUrl = window.location.href;

// Check if the URL contains 'adjustable-pillow-evg-usa-q-variants-usa'
if (currentUrl.includes('adjustable-pillow-evg-usa-q-variants-usa')) {
    // Check if the URL contains '/en-us'
    if (!currentUrl.includes('/en-us')) {
        // Check if the URL contains '/en-' followed by any language/region code and replace it with '/en-us'
        if (currentUrl.includes('/en-')) {
            currentUrl = currentUrl.replace(/\/en-[a-zA-Z0-9-]+\//, '/en-us/');
        } else {
            // If it doesn't contain '/en-', add '/en-us' before '/pages'
            currentUrl = currentUrl.replace('://drhonow.com/', '://drhonow.com/en-us/');
        }

        // Reload the page with the updated URL
        window.location.href = currentUrl;
    }
}
if (currentUrl.includes('/pages/price-usa-v2')) {
        window.location.href = "https://drhos.com/pages/price-usa-v2";
    
}

$(document).ready(function(){
const localStorageKey = 'geoPopupDismissed';
let now = Date.now();

// Check if popup was dismissed in last 24 hours
const popupSeen = localStorage.getItem(localStorageKey);
const isPopupActive = !(popupSeen && now < parseInt(popupSeen));

fetch('https://drhonow.com/browsing_context_suggestions.json')
  .then(res => res.json())
  .then(r => {
    let country = r?.detected_values?.country?.name;
    let hostname = window.location.hostname;
    let currentPath = window.location.pathname.replace(/^\/(en-us|en-ca|en-int)/i, '') + window.location.search;

    let showPopup = false;
    let redirectUrl = '';
$(".dyn-contry").text(country);
    // -------------------------
    // AUSTRALIA → show popup & redirect to AU site
    // -------------------------
    if (country === 'Australia' && hostname.includes('drhonow.com')) {
      showPopup = true;
      if (currentPath.includes("/products/dr-hos-motionciser")) {
        showPopup = false;
        redirectUrl = 'https://www.globalshop.com.au/products/Dr-Hos-Motionciser?utm_source=drhos&utm_campaign=dr_hos_motion_solution_mat&utm_medium=redirect&utm_content=DHMS';
         window.location.href = redirectUrl;
      } else {
        showPopup = true;
        redirectUrl = 'https://www.globalshop.com.au/categories/Dr-Hos-products';
      }
      
    }

    // -------------------------
    // USA → show popup & redirect to drhos.com
    // -------------------------
    if (country === 'United States' && hostname.includes('drhonow.com')) {
      showPopup = true;

      // Special case for motionciser
      if (currentPath.includes("/pages/price-can-mc-fit-drhos-ctv")) {
        showPopup = false;
        redirectUrl = 'https://drhos.com/pages/motionciser-ps-usa-v2-ctv';
         window.location.href = redirectUrl;
      } else {
        redirectUrl = 'https://drhos.com' + currentPath;
      }
    }

    // -------------------------
    // CANADA → show popup & redirect to drhonow.com
    // -------------------------
    if (country === 'Canada' && hostname.includes('drhos.com')) {
      showPopup = true;
      redirectUrl = 'https://www.drhonow.com' + currentPath;
    }

    // -------------------------
    // SHOW POPUP (if needed)
    // -------------------------
    if (showPopup && isPopupActive) {
      $('.userCountry').text(country);
      $('#geoPopup').fadeIn();
      $("html").addClass("lock-all");

      // Redirect button
      $('#redirectBtn').off().on('click', () => {
        window.location.href = redirectUrl;
      });

      // Close popup
      $('.stay, #geoClose').off().on('click', () => {
        $('#geoPopup').fadeOut();
        $("html").removeClass("lock-all");

        if ($('#dontShowAgain').is(':checked')) {
          const oneDay = 24 * 60 * 60 * 1000;
          localStorage.setItem(localStorageKey, (now + oneDay).toString());
        }
      });

      // Close when clicking outside
      $(document).on("click", ".pop-up-video-geo", function(e) {
        if (e.target == this) {
          $('#geoPopup').fadeOut();
          $("html").removeClass("lock-all");
        }
      });
    }
  })
  .catch(err => {
    console.error('Geo popup error:', err);
  });
  
    $(".nav-sl-hp-p").slick({
    slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  dots:false,
  vertical: true,
      infinite:false,
verticalSwiping: true,
  asNavFor: '.main-s-hp-p',
      focusOnSelect: true,
          responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow:4,
        }
      },

     ]
   });
     $(".main-s-hp-p").slick({
    slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:false,
 infinite:false,
  asNavFor: '.nav-sl-hp-p',
       responsive: [
      {
        breakpoint: 750,
        settings: {
    slidesToShow:1.07,
          dots:true,
        }
      },
         ]
   });
    
  
  $('.mobile-contact-us').append($('a.telephone-number').clone());
  $(document).on("click", ".main-slider-parent-bfcm img", function() {
    var redirectUrl = $(this).attr("data-attr"); // Get the data-attr value
    if (redirectUrl && redirectUrl !== "") { // Check if it's not empty
      window.location.href = redirectUrl; // Redirect to the URL
    }
  });
  if($(window).width() < 992){
    $(".last-slide-desk").remove();
  $('.main-parent-banner-slick').contents().unwrap();  
     $(".left-side-img-banner").slick({
    slidesToShow: 2.9,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:true,
     autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
        cssEase: 'linear',
  pauseOnHover: false
   });
     $(".right-side-desc-key").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
   infinite:false,
        appendArrows: false,
     
   });
    
  }
  $('.right-side-desc-key').on('afterChange', function(event, slick, currentSlide, nextSlide){
$('.key-f-pdp .new-dot').removeClass("active-d");
    $('.key-f-pdp .new-dot').eq(currentSlide).addClass('active-d');

 var $currentSlide = $(slick.$slides[currentSlide]);
  var datatabid = $currentSlide.attr('data-imgt-id');
$(".key-f-pdp .left-img-key .with-tab-img img").removeClass("active-tab-k-img");

$(".key-f-pdp .left-img-key .with-tab-img img#" + datatabid).addClass("active-tab-k-img");

});
$(".main-parent-banner-slick").slick({
    slidesToShow: 1.83,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  arrows: false,
  cssEase: 'linear',
  vertical: true,
verticalSwiping: true,
  
     
   });
  $(".slider-left-img .left-img-what").slick({
    slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
    autoplaySpeed: 5000,
  speed: 500,
  pauseOnHover: false,
    dots:true,
    arrows:false,
     
   });
  $(document).on("click", ".top-tab-desc p,.top-tab-desc a", function() {
    var datatabpdp = $(this).attr("data-tab-id");
    $(".top-tab-desc p,.top-tab-desc a").removeClass("active");
    $(this).addClass("active");
    $(".tabs-data").hide();
    $(".tabs-data#"+datatabpdp).show();
    if (this.tagName.toLowerCase() === "a") {
      $(".top-tab-desc p").first().click();
      
    }
    
  });
$(document).on("click", "mobile-navigation .search-button-mobile-d", function() {
        $("mobile-navigation .drawer__close-button")[0].click();
        $(".shopify-section--header .header-search-mob")[0].click();
    });
  $(document).on("click", ".custom-top-drawer-btn button.drawer__close-button", function(event) {
   
    event.preventDefault();
    
  $("mobile-navigation .drawer__close-button")[0].click();
     return;
                 });
  $(document).on("click", ".footer__item.footer__item--links .footer__item-title", function() {
    if($(window).width() < 992){
    $(this).toggleClass("active-btn-tgl");
    $(this).next(".footer__item-content").slideToggle();
    }
  });
   $(".announcement-bar__list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:true,
     
   });
  
   $(".shopify-section--collection-list .list-collections__item-list-new").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        appendArrows: $(".shopify-section--collection-list .responsive-arrows-coll.desktop-arrows"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow:3,
          appendArrows: $(".shopify-section--collection-list .responsive-arrows-coll.mob-arrows-s"),
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".shopify-section--collection-list .responsive-arrows-coll.mob-arrows-s"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.12,
          appendArrows: $(".shopify-section--collection-list .responsive-arrows-coll.mob-arrows-s"),
        }
      }
      
    ]
  });
   if($(window).width() > 749){
  $(".main-slider-sci-cli").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //  centerMode:true,
    //       centerPadding:'120px',
   infinite:true,
        appendArrows: $(".sci-and-cli .responsive-arrows-coll.desktop-arrows"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow:3,
          appendArrows: $(".sci-and-cli .responsive-arrows-coll.mob-arrows-s"),
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".sci-and-cli .responsive-arrows-coll.mob-arrows-s"),
        }
      }
      
    ]
  });
}
 $(".slider-upcoming").slick({
    slidesToShow: 2.87,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        
    responsive: [
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".up-coming-s .responsive-arrows-coll"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1,
          appendArrows: $(".up-coming-s .responsive-arrows-coll"),
        }
      }
      
    ]
  });
 var slideshv, shliderd, slideshr, centerm, appendArrowsOption;

var $slider = $(".slider-videos");

// Only run for NON product name template
if (!$("body").hasClass("main-t-name-product")) {

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    appendArrows: $(".video-popups-hp .responsive-arrows-coll.desktop-arrows"),

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          appendArrows: $(".video-popups-hp .responsive-arrows-coll.desktop-arrows"),
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: false,
          appendArrows: $(".video-popups-hp .responsive-arrows-coll.mob-arrows-s"),
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          dots: false,
          centerMode: true,
          centerPadding: "18px",
          appendArrows: $(".video-popups-hp .responsive-arrows-coll.mob-arrows-s"),
        }
      }
    ]
  });

} else {
var slidevideoCount = $(".video-with-pop .slider-videos").attr("data-video-count");
    
  var slidevideoCount = (slidevideoCount == "3") ? 3 : 3.15;
  
  // Product page slider
  $slider.slick({
    slidesToShow: slidevideoCount,
    slidesToScroll: 1,
    arrows: true,
   dots: false,
    infinite: false,
    // No appendArrows here

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1.1,
          dots: true,
          arrows: false,
          centerMode: false,
          
        }
      }
    ]
  });
}

   $(".slider-parent-insta").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:true,
        appendArrows: $(".insta-section .responsive-arrows-coll.desktop-arrows"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
          appendArrows: $(".insta-section .responsive-arrows-coll.desktop-arrows"),
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".insta-section .responsive-arrows-coll.mob-arrows-s"),
          
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1,
          appendArrows: $(".insta-section .responsive-arrows-coll.mob-arrows-s"),
          centerMode:true,
          centerPadding:'18px',
          
        }
      }
      
    ]
  });
  $(".new-hp-blg-sec .blog-cards__grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
     
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          
          
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.12,
    dots:true,
         
          
        }
      }
    ]
  });
 $(".collection-slider-section:not(.coll-slider-hp) .product-list__inner").slick({
    slidesToShow: 4.25,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        appendArrows: $(".collection-slider-section .responsive-arrows-coll.desktop-arrows"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3.87,
    
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".collection-slider-section .responsive-arrows-coll.mob-arrows-s"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.12,
          appendArrows: $(".collection-slider-section .responsive-arrows-coll.mob-arrows-s"),
        }
      }
      
    ]
  });

 


  $(".collection-slider-section.coll-slider-hp:not(.product-facet) .product-list__inner").slick({
    slidesToShow: 4.25,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        appendArrows: $(".collection-slider-section.coll-slider-hp .responsive-arrows-coll.desktop-arrows"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3.87,
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".collection-slider-section .responsive-arrows-coll.mob-arrows-s"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.12,
          appendArrows: $(".collection-slider-section .responsive-arrows-coll.mob-arrows-s"),
        }
      }
      
    ]
  });
setInterval(() => {
  $(".collection-slider-section.product-facet").each(function () {
    const $slider = $(this).find(".product-list__inner");
   if ($slider.length && !$slider.hasClass("slick-initialized")) {
    $slider.slick({
      slidesToShow: 4.25,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.87,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1.12,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }
});
}, 500);

 $(".customer-review-slider .main-review-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
   responsive: [
      {
        breakpoint: 992,
        settings: {
          appendArrows: $(".customer-review-slider .responsive-arrows-coll"),
    
        }
      }
          ]
   
 });
  
  $('.main-pdp-be-af .slider-block-insta').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      // appendArrows: $(".main-pdp-be-af .responsive-arrows-coll"),
      responsive: [
         {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
    arrows: false,
     dots:true
        }
      },
      
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
             arrows: false,
           dots:true
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
              arrows: false,
           dots:true
           
          },
        },
      ],
    });
      var reliefSlider = $("body.pdp-temp-new-pdps .pdp-relief-img-text");
     var reliefSlidesDesktop = parseInt(reliefSlider.data("slides-desktop"), 10) || 3;
     reliefSlider.slick({
    slidesToShow: reliefSlidesDesktop,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
      
      
       {
        breakpoint: 741,
        settings: {
    slidesToShow: 2,
           dots: true,
          
        }
      },
                                    {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.12,
          dots: true,
        }
      }
      
    ]
  });
  $(".slider-video-right-see").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
                             {
        breakpoint: 577,
        settings: {
    slidesToShow: 2.5,
          
          
          
        }
      }
      
    ]
  });
  $(document).on("click", ".single-sl-sci-cli svg", function(event) {
        $(".single-sl-sci-cli").not($(this).parents(".single-sl-sci-cli")).removeClass("active-sl");
      $(this).parents(".single-sl-sci-cli").toggleClass("active-sl");
  });


$(document).on("click", "a.youtube-pop-video", function(event) {
  
event.preventDefault();
  var attrval = $(this).attr("href");
  if(attrval != ""){
  $(".pop-up-video video").attr('src',attrval);
  $(".pop-up-video").show();
  $("html").addClass("lock-all");
    if($(this).hasClass("with-html-data")){
      $(".pop-up-video").addClass("with-html-dt-pp");
      
      var includedDivs = $(this).parents(".single-block-video").children().not('.image-pop-up-v').clone(); 
      $(".pop-up-video.with-html-dt-pp .pop-up-video-data-vis").html("");
      $(".pop-up-video.with-html-dt-pp .pop-up-video-data-vis").html(includedDivs)
    }
    else{
      $(".pop-up-video").removeClass("with-html-dt-pp");
    }
  }
});
  $(document).on("click", ".video-popups-hp .client-name-p-desk span", function(event) {
    $(this).parents(".single-block-video").find("a.youtube-pop-video").click();
  });
  $(document).on("click", ".data-for-pop p.button.button--primary", function(event) {
    $(".pop-up-video.pdp-page-pop").show();
  $("html").addClass("lock-all");
    
  });
  $(document).on("click", ".featured-prod-main button#AddToCart", function(event) {
    setTimeout(function(){
    $(".pop-up-video.pdp-page-pop").hide();
  $("html").removeClass("lock-all");
      $(".pop-up-video").removeClass("with-html-dt-pp");
      },1000);
  });
  
$(document).on("click", ".pop-up-video", function(e) {
  
 if (e.target == this){
    $(".pop-up-video").hide();
    $(".pop-up-video video").attr('src','');
    $("html").removeClass("lock-all");
   $(".pop-up-video").removeClass("with-html-dt-pp");
  }
});
   $('.pop-up-video video').on('click', function(event) {
    event.stopPropagation();
  });
  $(document).on("click", ".close-with-iframe #close-main-iframe", function(event) {
    $(".pop-up-video").hide();
    $(".pop-up-video video").attr('src','');
    $("html").removeClass("lock-all");
    $(".pop-up-video").removeClass("with-html-dt-pp");
  });

$(document).on("click", ".risk-free-flex a,.main-pdp-section .main-get-back-p a", function(event) {
  
event.preventDefault();
 
  $(".popup-text-div").show();
  $("html").addClass("lock-all");

});
$(document).on("click", ".popup-text-div", function(e) {
   if (e.target == this){
  $(".popup-text-div").hide();
    $("html").removeClass("lock-all");
  }
});
  $(document).on("click", ".popup-text-div svg", function(e) {
 $(".popup-text-div").hide();
    $("html").removeClass("lock-all");
  
});

$(document).on("click", ".product-form .product-form__option-info .size-option-trigger", function(event) {
  
event.preventDefault();
 
  $(".size-chart-pop-up").show();
  $("html").addClass("lock-all");

});
$(document).on("click", ".size-chart-pop-up", function(e) {
   if (e.target == this){
  $(".size-chart-pop-up").hide();
    $("html").removeClass("lock-all");
  }
});
  $(document).on("click", ".size-chart-pop-up svg", function(e) {
 $(".size-chart-pop-up").hide();
    $("html").removeClass("lock-all");
  
});


$(document).on("click", ".single-block-ad a", function(event) {
  
event.preventDefault();
 
  $(this).parent().find(".doc-pop-data").show();
  $("html").addClass("lock-all");

});
$(document).on("click", ".doc-pop-data", function(e) {
   if (e.target == this){
  $(".doc-pop-data").hide();
    $("html").removeClass("lock-all");
  }
});
  $(document).on("click", ".single-block-ad svg", function(e) {
 $(".doc-pop-data").hide();
    $("html").removeClass("lock-all");
  
});




$(document).on("click", ".show-slider-all", function(event) {
  
event.preventDefault();
 
  $(".slider-with-close").show();
  $("html").addClass("lock-all");
  
     $(".slider-main-pop").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
});
});
$(document).on("click", ".slider-with-close", function(e) {
   if (e.target == this){
  $(".slider-with-close").hide();
     $(".slider-main-pop.slick-initialized").slick('unslick');
    $("html").removeClass("lock-all");
  }
});
  $(document).on("click", ".slider-with-close svg", function(e) {
    
 $(".slider-with-close").hide();
    $(".slider-main-pop.slick-initialized").slick('unslick');
    $("html").removeClass("lock-all");
  
});

$(document).on("click", "#main-prod-section-media .product__media-item[data-media-type='image']", function(e) {
  
  if($(window).width() > 999){
  var index = $(this).index();
  $(".slider-with-close").css("opacity",0);
  $(".show-slider-all").click();
  setTimeout(function() {
    $('.slider-main-pop').slick('slickGoTo', index);
  }, 10);
  setTimeout(function() {
    $(".slider-with-close").css("opacity",1);
  }, 600);
  }
});



  


  
  $(document).on("click", ".faq-que", function() {
    $(".main-faq-single").not($(this).parents(".main-faq-single")).removeClass("active-faq");
      $(this).parents(".main-faq-single").toggleClass("active-faq");
    $(".faq-ans").not($(this).next(".faq-ans")).slideUp(); 
    $(this).next(".faq-ans").slideToggle(); 
    if($(this).hasClass("with-sl-ince")){
      $(".what-inc-tab-s.slick-initialized").slick('unslick');
      $(".what-inc-tab-s:not(.slick-initialized)").slick({
    slidesToShow: 4.5,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
   infinite:false,    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
     
            {
        breakpoint: 750,
        settings: {
    slidesToShow: 2.4,
          
        }
      }
      
    ]
  });
    }
  });

  $(document).on("click", ".key-f-pdp.accord-key-f .swiper-slide .count-k-tt", function() {
    $(".count-k-tt").not($(this)).removeClass("active-faq-t");
      $(this).toggleClass("active-faq-t");
    $(".text-desc-key").not($(this).next(".text-desc-key")).slideUp(); 
    $(this).next(".text-desc-key").slideToggle(); 
    var datatabid = $(this).parents(".swiper-slide").attr("data-imgt-id");
$(".key-f-pdp .left-img-key .with-tab-img img").removeClass("active-tab-k-img");

$(".key-f-pdp .left-img-key .with-tab-img img#" + datatabid).addClass("active-tab-k-img");
  });

  $(document).on("click", ".total-drawer-count ", function () {
      $(this).toggleClass("active-tabs-toggle");
$(".subtotal-parent").slideToggle();
    });
  
 function updateButtonPosition() {
    var $container = $('.shopify-section--header .container').first();
    var parentWidth = $container.parent().width();
    var divWidth = $container.outerWidth();

    // Calculate the left margin
    var computedLeftMargin = (parentWidth - divWidth) / 2;
    console.log('Computed left margin:', computedLeftMargin);

    // Set the right property of the buttons based on the computed left margin
    // $(".collection-slider-section button.slick-next.slick-arrow").css("right", -computedLeftMargin + 'px');
    $(".shopify-section--collection-list button.slick-next.slick-arrow").css("right", -computedLeftMargin + 'px');
   $(".slider-upcoming button.slick-next.slick-arrow").css("right", -computedLeftMargin + 'px');
}
   updateButtonPosition();
  $(window).resize(function() {
    updateButtonPosition();
});
 $(document).on("click", "p.read-more-less", function () {

  const isFrench = document.documentElement.lang === "fr";

  if (
    (isFrench && $(this).text().trim() === "Lire moins") ||
    (!isFrench && $(this).text().trim() === "Read Less")
  ) {

    $(this).parent().find(".sort-desc").show();
    $(this).parent().find(".long-desc").hide();

    $(this).text(isFrench ? "Lire plus" : "Read More");

  } else {

    $(this).parent().find(".sort-desc").hide();
    $(this).parent().find(".long-desc").show();

    $(this).text(isFrench ? "Lire moins" : "Read Less");
  }

});
  $(".shopify-section--main-product .product-quantity-selecta").on("change",function(){ 
  $(".shopify-section--main-product .quantity-selector__input").val($(this).val());
    $(".shopify-section--main-product quantity-selector button").last().click();
  });

$(document).on("click", ".key-f-pdp .new-dot", function() {
   if($(window).width() < 992){
     $('.right-side-desc-key').slick('slickGoTo', $(this).attr("data-index"));
   }
});
   $(".tag-group.active-tag-data").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
       appendArrows: $(".prev-video-sec .responsive-arrows-coll"), 
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3.1,
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".prev-video-sec .responsive-arrows-coll"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1,
          appendArrows: $(".prev-video-sec .responsive-arrows-coll"),
          centerMode:true,
          centerPadding:'45px',
          infinite:true,
        }
      }
      
    ]
  });
$(document).on("click", ".button-tag-vid p", function() {
  $(".button-tag-vid p").removeClass("active-tag-tab");
  $(this).addClass("active-tag-tab");
  $(".tag-group").removeClass("active-tag-data");
 $("#"+$(this).attr("data-id")).addClass(" active-tag-data");
  $(".tag-group.slick-initialized").slick('unslick');
   $(".tag-group.active-tag-data").slick({
    slidesToShow: 4.2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
       appendArrows: $(".prev-video-sec .responsive-arrows-coll"), 
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3.1,
        }
      },
       {
        breakpoint: 992,
        settings: {
    slidesToShow: 2,
          appendArrows: $(".prev-video-sec .responsive-arrows-coll"),
        }
      },
       {
        breakpoint: 577,
        settings: {
    slidesToShow: 1,
          appendArrows: $(".prev-video-sec .responsive-arrows-coll"),
          centerMode:true,
          centerPadding:'45px',
          infinite:true,
        }
      }
      
    ]
  });
});
 


$(document).on("click", ".aov-booster-main .button", function() {
  $("html").addClass("lock-all");
  var aovid = $(this).attr("data-aov-id");
$(".aov-booster-product-model").addClass("active");
$(".single-product-aov-m").removeClass("active");
$(".single-product-aov-m[data-aov='" + aovid + "']").addClass("active");
$(".single-product-aov-m.active .main-par-slider-aov.slick-initialized").slick('unslick');
    $(".single-product-aov-m.active .small-thum-slider-aov.slick-initialized").slick('unslick');
// setTimeout(function(){
 $(".single-product-aov-m.active .small-thum-slider-aov").slick({
    slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  dots:false,
 
      infinite:false,
  asNavFor: '.single-product-aov-m.active .main-par-slider-aov',
      focusOnSelect: true,
        responsive: [
      {
        breakpoint: 750,
        settings: {
    slidesToShow:5.5,
          
        }
      },
         ]
   });
 $(".single-product-aov-m.active .main-par-slider-aov").slick({
    slidesToShow: 1.11,
  slidesToScroll: 1,
  arrows: true,
  dots:false,
 infinite:false,
  asNavFor: '.single-product-aov-m.active .small-thum-slider-aov',
       responsive: [
      {
        breakpoint: 750,
        settings: {
    slidesToShow:1.4,
          
        }
      },
         ]
   });
  //  },100);
});
$(document).on("click", ".aov-booster-product-model", function(e) {
   if (e.target == this){
  $(".aov-booster-product-model").removeClass("active");
    $("html").removeClass("lock-all");
    $(".single-product-aov-m").removeClass("active");
    $(".single-product-aov-m.active .main-par-slider-aov.slick-initialized").slick('unslick');
    $(".single-product-aov-m.active .small-thum-slider-aov.slick-initialized").slick('unslick');
  }
});
  $(document).on("click", ".aov-booster-product-model svg.close", function(e) {
 $(".aov-booster-product-model").removeClass("active");
    $("html").removeClass("lock-all");
    $(".single-product-aov-m").removeClass("active");
    $(".single-product-aov-m.active .main-par-slider-aov.slick-initialized").slick('unslick');
    $(".single-product-aov-m.active .small-thum-slider-aov.slick-initialized").slick('unslick');

  
});
 $(document).on("click", ".right-side-p-desc-aov button.product-item__cta", function(e) {
  setTimeout(function(){
 $(".aov-booster-product-model").removeClass("active");
    $("html").removeClass("lock-all");
    $(".single-product-aov-m").removeClass("active");
    $(".single-product-aov-m.active .main-par-slider-aov.slick-initialized").slick('unslick');
    $(".single-product-aov-m.active .small-thum-slider-aov.slick-initialized").slick('unslick');
},1000);
  
});
$(document).on("click", ".aov-variant-selet p", function(e) {
  $(this).parents(".aov-variant-selet").find("p").removeClass("active");
  $(this).addClass("active");
  var priceaov = $(this).attr("data-aov-v-p");
  var varavai = $(this).attr("data-aov-avai");
  var varidaov = $(this).attr("data-aov-id");
  $(this).parents(".right-side-p-desc-aov").find(".prod-price-aov").text(priceaov);
  $(this).parents(".right-side-p-desc-aov").find(".atc-price-aov").text(priceaov);
  $(this).parents(".right-side-p-desc-aov").find(".variant-id-aov").val(varidaov);
  
  if(varavai == true ||  varavai == "true"){
$(this).parents(".right-side-p-desc-aov").find(".button.product-item__cta").removeClass("disabled");
  }
  else{
$(this).parents(".right-side-p-desc-aov").find(".button.product-item__cta").addClass("disabled");
  }
});
$(".header__linklist-item.slider-nav-d").hover(
   function () {
 var slidesh;

  if ($(this).find(".list-of-blocks-dn").hasClass("collection-list-with-l")) {
    slidesh = 3;
  } else {
    slidesh = 4.4;
  }
  
    $(".list-of-blocks-dn.slick-initialized").slick('unslick');
  $(this).find(".list-of-blocks-dn").slick({
    slidesToShow: slidesh,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
       appendArrows: $(this).find(".header-custom-arows"), 
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3.1,
        }
      },
    ]
  });
}
)
      $(".features-grid-four:not(.pdp-feat-s) .main-slider-four").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
      
      
       {
        breakpoint: 741,
        settings: {
    slidesToShow: 2,
          
          
        }
      },
            {
        breakpoint: 577,
        settings: {
    slidesToShow: 1,
          dots:true
        }
      }
      
    ]
  });
var slideCount = $(".features-grid-four.pdp-feat-s .main-slider-four:not(.no-slider-refor)").attr("data-slide-f");
    
  var slidesToShowValue = (slideCount == "3") ? 3 : 4;
 $(".features-grid-four.pdp-feat-s .main-slider-four:not(.no-slider-refor), .features-grid-passm .main-slider-four:not(.no-slider-refor)").slick({
    slidesToShow: slidesToShowValue,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
      
      
       {
        breakpoint: 741,
        settings: {
    slidesToShow: 2,
          dots:true,
          
        }
      },
            {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.1,
          dots:true
        }
      }
      
    ]
  });
  $(document).on("click", "p.atc-btn-l", function(e) {
  $(".popup-text-div .popup-data svg").trigger("click")
  $(".shopify-section--main-product .pdp-atc-qty button.product-form__add-button").trigger("click");
});

// Set your multiplier
$(document).on("click", ".shopify-section--main-product .pdp-atc-qty .quantity-selector button", function(e) {
  setTimeout(function(){
var multiplier = $(".shopify-section--main-product .pdp-atc-qty .quantity-selector .quantity-selector__input").val();
  var $el = $('.shopify-section--main-product .pdp-atc-qty span.product-price-btn');

  var priceStr = $el.data('main-p-btn').toString().trim();
  var cpStr = $el.data('main-cp-btn').toString().trim();

  // Regex: [currency symbol] [amount] [currency code]
  function parsePrice(str) {
    var match = str.match(/([^0-9.,]+)?\s*([\d.,]+)\s*([A-Za-z]+)?/);
    if (match) {
      return {
        symbol: match[1] ? match[1].trim() : '',
        amount: parseFloat(match[2].replace(/,/g, '')),
        code: match[3] ? match[3].trim() : ''
      };
    }
    return null;
  }

  var mainPrice = parsePrice(priceStr);
  var cpPrice = parsePrice(cpStr);

  if (mainPrice) {
    // Multiply
    var newMain = (mainPrice.amount * multiplier).toFixed(2);
    var newMainStr = `${mainPrice.symbol}${newMain} ${mainPrice.code}`.trim();

    // Update attributes
    $el.attr('data-main-p-btn', newMainStr);

    // Start HTML with main <strong>
    var html = `·<strong>${newMainStr}</strong>`;

    // If cpPrice is valid and not zero → add <em>
    if (cpPrice && cpPrice.amount > 0) {
      var newCp = (cpPrice.amount * multiplier).toFixed(2);
      var newCpStr = `${cpPrice.symbol}${newCp} ${cpPrice.code}`.trim();
      $el.attr('data-main-cp-btn', newCpStr);
      html += ` <em>${newCpStr}</em>`;
    } else {
      // Reset cp to 0 if invalid
      $el.attr('data-main-cp-btn', 0);
    }

    // Update visible HTML
    $el.html(html);
  }
},200);
});




$(document).on('click', '.mini-cart__recommendations-inner .arrow-slider-cart button', function() {
  let $wrapper = $('.mini-cart__recommendations-list');
  let slideWidth = $('.shopify-section--mini-cart .mini-cart__recommendations .product-item').outerWidth(true);
  let scrollAmount = $(this).hasClass('slick-next') ? slideWidth : -slideWidth;

  $wrapper.animate({
    scrollLeft: $wrapper.scrollLeft() + scrollAmount
  }, 400);
});
$(document).on('click', '.inline-video-fl video', function() {
  if (this.paused) {
    this.play();
  } else {
    // this.pause();
  }
});

$(".inline-video-fl video").on("play", function () {
  $(this).parents(".inline-video-fl").find("svg").hide();
  $(this).attr("controls", true); // show controls
});

$(".inline-video-fl video").on("pause", function () {
  $(this).parents(".inline-video-fl").find("svg").show();
  $(this).removeAttr("controls"); // remove controls
});
var isMobile = window.innerWidth < 750;

  $(".doctor-video").each(function () {
    if (isMobile) {
      // Mobile → remove desktop video
      $(this).find(".video-revdesk").remove();
    } else {
      // Desktop → remove mobile video
      $(this).find(".video-revmob").remove();
    }
  });
$(".doctors-choose-slider")
  .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
     arrows: false,
      dots: true,
        }
      },
      
    ]
  })
  .on("afterChange", function () {
    $(".doctors-choose-slider video").each(function () {
      this.pause();
    });
  });
$(document)
  .off('click', '.custom-add-to-cart')
  .on('click', '.custom-add-to-cart', function(e) {

    e.preventDefault();

    var $form = $(this).closest('form');

    if ($form.data('processing')) return;
    $form.data('processing', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $form.serialize(),
      dataType: 'json',
      success: function(response) {

        // Refresh cart
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        // Open Focal drawer properly
        var miniCart = document.getElementById('mini-cart');
        if (miniCart) {
          miniCart.open = true;
        }

      },
      complete: function() {
        $form.data('processing', false);
      }
    });

});


  
  // new hp v3
 $(".new-hp-pd-s .new-hp-products__grid").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:false,
       
    responsive: [
      {
        breakpoint: 1200,
        settings: {
    slidesToShow: 3,
        }
      },
      
      
       {
        breakpoint: 741,
        settings: {
    slidesToShow: 2,
          dots:true,
          
        }
      },
            {
        breakpoint: 577,
        settings: {
    slidesToShow: 1.25,
          dots:true
        }
      }
      
    ]
  });



  });
  document.addEventListener('click', function(event) {
  // Check if the clicked element (or any of its parents) is the Tolstoy button
  const tolstoyButton = event.target.closest('button.tolstoy-product-tile-button');
  
  if (tolstoyButton) {
    // We captured the click! Now run your cart logic
    setTimeout(function() {
      
      // Tell the Focal theme to refresh the cart contents
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      // Open the Focal drawer properly
      const miniCart = document.getElementById('mini-cart');
      if (miniCart) {
        miniCart.open = true;
      }
      
    }, 2000); // Note: I reduced this from 3000ms to 1500ms for a better user experience, adjust as needed.
  }
}, true);
